// extracted by mini-css-extract-plugin
export default {"container":"errorboundary_container__HE59I","title":"errorboundary_title__Mcecv","subtitle":"errorboundary_subtitle__cQURO","text":"errorboundary_text__KLUHY"};